export const cilWindowMinimize = ["24 24","<path d='M2.25 21h19.5v1.5h-19.5v-1.5z'></path>"]